import { StatusBar } from 'expo-status-bar';
import { Linking } from 'react-native';
import React, { useEffect, useState } from 'react';
import { View, Image, TouchableOpacity, Alert, ScrollView, KeyboardAvoidingView, TouchableWithoutFeedback, Keyboard } from 'react-native';
import { TextInput, Button, Text } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { apiFetch } from '../modules/api';
import styles from './styles';
import theme from './../../lib/theme.js';
import {setVariables} from '../modules/component/variables';

export default function Acceso() {

  const emptyForm ={
    empresa: "",
    usuario: "",
    contrasena: ""
  };

  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [canContinueForm, setCanContinueForm] = useState(false);
  const [state, setState] = useState(emptyForm);
  const [event, setEvent] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const platform = typeof Platform === "undefined" ? 'web' : Platform;
  const [installed, setInstalled] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertText2, setAlertText2] = useState("Obteniendo ubicación...");
  const navigation = useNavigation({

    Acceso: {
      screen: 'Acceso',
      navigationOptions: {
        headerShown: false
      },

    }

  });

  const handleOpenPWA = () => {
    const customURL = 'web+promotoriaEurekaMx://abrir/usuario/juan';
    Linking.openURL(customURL).catch((err) => {
      console.warn('No se pudo abrir la PWA:', err);
    });
  };

  const installPWA = async () => {
    setIsLoading(true);
    if (!event) {
      return;
    }
    const result = await event.prompt();
    disableInAppInstallPrompt();
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }

  const disableInAppInstallPrompt = () => {
    setEvent(null);
    setShowInstallButton(false);
  }

  const isInStandaloneMode = () => {
    const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
    if ((/android/i.test(userAgent)) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
      return window.matchMedia('(display-mode: standalone)').matches;
    }else{
      return true;
    }
  }

  useEffect(() => {
    let mounted = true;
    gPantalla = "";
    setInstalled(isInStandaloneMode);
    window.addEventListener("beforeinstallprompt", (event) => {
      setEvent(event);
      setShowInstallButton(true);
    });
    return () => mounted = false;
  }, []);


  

  const handleChangetest = (name, value) => {
    setState({ ...state, [name]: value.trim() })
  }

  const limpiarFormulario = () => {
    setState(emptyForm)
  }

  const showAlert = () => {
    alert(gMsg);
  }
   


  async function validaAcceso() {
    setVariables();
    if(isLoading || canContinueForm){
      return false;
    }
    setIsLoading(true);
    var datos = {
      empresa: state.empresa,
      usuario: state.usuario,
      contrasena: state.contrasena
    };

    var requestOptions = {
      method: 'POST',
      headers: { "Content-Type": "application/json", 'Accept': 'application/json' },
      body: JSON.stringify(datos)
    };

    const response = await apiFetch(gApiPath + "/api/login", requestOptions);
    let json = response;
    try{
      json = await response.json();
    }catch (error){
      console.log(json);
      gMsg = 'El servicio no está disponible, favor de intentar mas tarde';
      limpiarFormulario();
      setIsLoading(false);
      showAlert();
      return;
    }
    
    if (json.estatus == "bien") {

      datos = json.datos
      gEmpresa = state.empresa;
      gUsuario = state.usuario;
      gIdUsuario = datos["id"];
      gToken = json.token;

      limpiarFormulario();

      navigation.navigate('Dashboard');

    } else {
      console.log(json);
      gMsg = json.mensaje;
      limpiarFormulario();
      showAlert();

    }
    setIsLoading(false);
  }

  useEffect(()=>{
    if(state.contrasena.trim() !== "" && state.empresa.trim() !== "" && state.usuario.trim() !== ""){
      setCanContinueForm(false);
    }else{
      setCanContinueForm(true);
    }
  },[state])
  
  return (
    <KeyboardAvoidingView behavior={platform === 'ios' ? 'padding' : 'height'} style={styles.mainContainer}>
        <View >
          <Fondo />
          <ScrollView style={styles.container} keyboardShouldPersistTaps='handled'>
            <View style={styles.imageLoginContainer}>
              <Image
                source={require('./logo.png')}
                contentFit="contain"
                transition={1000}
                style={{width: 90, height: 105}}
              />
              <Text variant="displayMedium" style={{ fontWeight: 900, color: "#0a2f58", fontStyle: "normal" }}>Eureka</Text>
            </View >
            {(showInstallButton || !installed) ? (
            <>
              {showInstallButton && (
                <Button onPress={() => installPWA()} loading={isLoading} mode="contained" style={{ marginTop: 20, marginBottom: 10, minHeight: "40px", justifyContent: "center" }}>
                    Instalar aplicación
                </Button>
              )}
              {!showInstallButton && (
                  <View style={{alignItems: 'center', justifyContent: "center", width: "100%"}} >
                    <Text style={{...theme.banner, color: theme.colors.success, textAlign: "center", marginLeft: 0}}>¡La aplicación se instaló correctamente!</Text>
                    <Text style={{textAlign: "center", marginVertical: "5%"}} >Ahora puedes encontrar <Text style={{fontWeight: 'bold'}}>Eureka Promotoría</Text> directamente en la pantalla de inicio de tu celular, como cualquier otra app.</Text>
                  </View>
              )}
            </>
            ):<>
            
            <TextInput
              mode='outlined'
              style={styles.textInput}
              label={"Empresa"}
              value={state.empresa}
              onChangeText={(value) => handleChangetest("empresa", value)}
            />
            <TextInput
              mode='outlined'
              label={"Usuario"}
              style={styles.textInput}
              value={state.usuario}
              onChangeText={(value) => handleChangetest("usuario", value)}
            />
            <TextInput
              secureTextEntry={true}
              mode='outlined'
              style={styles.textInput}
              label={"Contraseña"}
              value={state.contrasena}
              onChangeText={(value) => handleChangetest("contrasena", value)}
            />
            <StatusBar style="auto" />
            <Button onPress={() => validaAcceso()} disabled={canContinueForm} loading={isLoading} mode="contained" style={{ marginTop: 20, marginBottom: 10, minHeight: "40px", justifyContent: "center" }}>
                {!isLoading ? 'Accesar' : ''}
            </Button>
            </>}
            <TouchableOpacity >
              <Text style={{ textAlign: 'center' }} variant="labelMedium">Eureka Promotoria Version {versionApp}</Text>
            </TouchableOpacity>
          </ScrollView>
        </View>
    </KeyboardAvoidingView>
  );
}

